module.exports = __webpack_public_path__ + "media/img/prices/company-profile-d21f9abf5bccdec94becf3b9a81ffe3e.png";